<label mat-dialog-title class="mat-dialog-header">
  <span class="title">{{data.config.title}}</span><br />
  <span class="subtitle"
    ><b>{{data.config.description}}</b></span
  >
</label>

<mat-dialog-content style="max-height: max-content;" >
    <input
      id="fileImport"
      type="file"
      [(ngModel)]="fileValue"
      (change)="onFileChange($event)"
      multiple="false"
      accept=".xlsx, .xlsm"
      class="mb-3 mt-3 mat-stroked-button file-import"
      >
      <mat-form-field *ngIf="data.date">
        <mat-label>Fecha entrega</mat-label>
        <input
          matInput
          id="dispatchDate"
          [(ngModel)]="dispatchDate"
          [matDatepicker]="fromDatePicker"
          (dateChange)="changeFormat()"
          readonly
          autocomplete="off"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker [disabled]="!data.data.length"></mat-datepicker>
    </mat-form-field>
    <div class="mb-1">
      <app-data-table
          [type]="data.type"
          [data]="data.data"
          size="xl"
        >
      </app-data-table>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button
    mat-stroked-button
    id="cancelAction"
    (click)="onClose()"
    class="b-s m-2"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    (click)="onSubmitAction()"
    id="submitAction"
    [ngClass]="data.config.class"
    [disabled]="data.data && !data.data.length"
  >
    {{data.config.action}}
  </button>
</mat-dialog-actions>

<button
  mat-button
  id="closeAction"
  (click)="onClose()"
  class="dialog-close"
>
  <mat-icon>close</mat-icon>
</button>
